import React from "react";
import 'react-calendar/dist/Calendar.css';
import Lottie from 'react-lottie';
import { useNavigate, useParams } from 'react-router-dom';
import * as unsuccessAnimationData from '../../Animations/unsuccesful.json';

const OrderFailed = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    setTimeout(() => {
        navigate(`/${localStorage.getItem('role')}/${id}`);
    }, 3000);

    return (
        <>
            <div className="eventbar">
                <div className="successbar">
                    <Lottie options={{
                        loop: true,
                        autoplay: true,
                        animationData: unsuccessAnimationData,
                        rendererSettings: {
                            preserveAspectRatio: 'xMidYMid slice'
                        }
                    }}
                        height={160}
                        width={160}
                        isStopped={false} />
                    <h6>Order Failed</h6>
                </div>
            </div>
        </>
    );
}

export default OrderFailed;